module.exports = __webpack_public_path__ + "img/filter.4f6d0376.svg";